import { TypographyLevel } from '../typography';
import { Level } from './types';
import css from './style.module.css';

export const levelPresets: Record<Level, string> = {
  [TypographyLevel.FIRST]: css.first,
  [TypographyLevel.SECOND]: css.second,
};
